import { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router";

import { OverlayContainer, TooltipContainer } from "capitalrx-components-2.0/lib/general";

import { ExternalLinkModalProvider } from "@/basic/context";
import { ExternalLinkGuard, ExternalLinkModal } from "@/common/components/ExternalLinkModal";
import {
  ComparePlansPage,
  Home,
  MedicarePrescriptionPaymentPlan,
  Pharmacies,
  PharmacyDetailsPage,
  PlanDetailsPage,
  PlansPage,
  PrintPharmaciesPage,
} from "@/premium/pages";
import { enablePlansPageRedesign, enableComparePlansPage } from "@/utils/featureFlags";

export const PremiumRoutes: FC = (): JSX.Element => {
  return (
    <BrowserRouter>
      <OverlayContainer>
        <TooltipContainer>
          <ExternalLinkModalProvider>
            <ExternalLinkGuard />
            <ExternalLinkModal />
            <Routes>
              <Route path="/" element={<Home />} />
              {enablePlansPageRedesign() && <Route path="/plans" element={<PlansPage />} />}
              {enablePlansPageRedesign() && enableComparePlansPage() && <Route path="/compare-plans" element={<ComparePlansPage />} />}
              {enablePlansPageRedesign() && <Route path="/plans/plan-details" element={<PlanDetailsPage />} />}
              <Route path="/plans/plan-details/medicare-prescription-payment-plan" element={<MedicarePrescriptionPaymentPlan />} />
              <Route path="/plans/plan-details/pharmacies/pharmacy-details" element={<PharmacyDetailsPage />} />
              <Route path="/plans/plan-details/pharmacies" element={<Pharmacies />} />
              <Route path="/print-pharmacies" element={<PrintPharmaciesPage />} />
            </Routes>
          </ExternalLinkModalProvider>
        </TooltipContainer>
      </OverlayContainer>
    </BrowserRouter>
  );
};
